import React, { Component } from "react";
import "./NewInventoryItem.scss";
import { Link } from "react-router-dom";
import arrowBack from "../../assets/Icons/arrow_back-24px.svg";
import axios from "axios";

// const apiURL = `https://instock-api-rbht.onrender.com`;

class NewInventoryItem extends Component {
  state = {
    itemName: "",
    description: "",
    category: "",
    status: "",
    quantity: "",
    warehouseName: "",
  };

  componentDidMount() {
    document.title = "New Inventory Item";
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const details = {
      name: this.state.itemName,
      description: this.state.description,
      category: this.state.category,
    };
    const availablity = {
      status: this.state.status,
      quantity: this.state.quantity,
      warehouseName: this.state.warehouseName,
    };

    // calls isFormValid to make sure all inputs are valid before editing
    // if valid updated data is sent to backend
    console.log(availablity);
    console.log(details);
    if (this.isFormValid()) {
      axios
        .post("https://instock-api-rbht.onrender.com/api/v1/inventories", {
          details,
          availablity,
        })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // redirect them to home page

    this.props.history.goBack();
  };

  // function to check if form info fields are filled in
  isFormValid = () => {
    if (
      !this.state.itemName ||
      !this.state.description ||
      !this.state.category ||
      !this.state.status ||
      !this.state.quantity ||
      !this.state.warehouseName
    ) {
      return false;
    }
    return true;
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // returns user to home if cancel button is clicked
  handleCancel = (e) => {
    e.preventDefault();
    this.props.routerProps.history.push("/");
  };
  render() {
    return (
      <>
        <div className="backgroundNewInvent">
          <div className="page-position">
            <section className="newInventory">
              {/* Header */}
              <div className="newInventory__title-wrapper">
                <h1 className="newInventory__title">
                  <Link to="/inventory">
                    <img
                      className="newInventory__title--icon"
                      src={arrowBack}
                      alt="back arrow"
                    />
                  </Link>
                  Add New Inventory Item
                </h1>
              </div>
              <form
                className="newInventory-wrapper"
                onSubmit={this.handleSubmit}
              >
                <div className="newInventory-tablet-wrapper">
                  {/* Item details section*/}
                  <div className="newInventory__details">
                    <h2 className="newInventory__details--header">
                      Item Details
                    </h2>
                    {/* Item details form*/}
                    <div className="newInventory__form">
                      {/*Item Name */}
                      <label className="newInventory__form--label">
                        Item Name
                      </label>
                      <input
                        className="newInventory__form--input"
                        type="text"
                        onChange={this.handleChange}
                        value={this.state.itemName}
                        placeholder="Item Name"
                        name="itemName"
                      ></input>
                      {/* Description */}
                      <label className="newInventory__form--label">
                        Description
                      </label>
                      <textarea
                        className="newInventory__form--input description"
                        type="text"
                        onChange={this.handleChange}
                        value={this.state.description}
                        name="description"
                        placeholder="Please enter a brief item description..."
                      ></textarea>
                      {/* Category */}
                      <label className="newInventory__form--label">
                        Category
                      </label>
                      <select
                        className="newInventory__form--input"
                        onChange={this.handleChange}
                        value={this.state.category}
                        name="category"
                      >
                        <option value="select" disabled="">
                          Please select
                        </option>
                        <option value="Electronics">Electronics</option>
                        <option value="Gear">Gear</option>
                        <option value="Apparel">Apparel</option>
                        <option value="Accessories">Accessories</option>
                        <option value="Health">Health</option>
                      </select>
                    </div>
                  </div>
                  {/* Item Availability section*/}
                  <div className="newInventory__availability">
                    <h2 className="newInventory__availability--header">
                      Item Availability
                    </h2>
                    {/* Contact details form*/}
                    <div className="newInventory__form">
                      {/*Status In stock or out  */}
                      <label className="newInventory__form--label">
                        Status
                      </label>
                      <div className="newInventory__form--radio-container">
                        <input
                          className="newInventory__form--radioBtn"
                          type="radio"
                          value="In stock"
                          checked={this.state.status === "In stock"}
                          onChange={this.handleChange}
                          name="status"
                        ></input>
                        <label
                          className="newInventory__form--radio-label"
                          htmlFor="in-stock"
                        >
                          In stock
                        </label>

                        <input
                          className="newInventory__form--radioBtn"
                          type="radio"
                          value="Out of stock"
                          checked={this.state.status === "Out of stock"}
                          onChange={this.handleChange}
                          name="status"
                        ></input>
                        <label
                          className="newInventory__form--radio-label"
                          htmlFor="out-of-stock"
                        >
                          Out of stock
                        </label>
                      </div>
                      {/*Quantity */}
                      <label className="newInventory__form--label">
                        Quantity
                      </label>
                      <input
                        className="newInventory__form--input quantity"
                        type="text"
                        onChange={this.handleChange}
                        value={this.state.quantity}
                        placeholder="0"
                        name="quantity"
                      ></input>
                      {/*Warehouse*/}
                      <label className="newInventory__form--label">
                        Warehouse
                      </label>
                      <select
                        className="newInventory__form--input"
                        name="warehouseName"
                        onChange={this.handleChange}
                        value={this.state.warehouseName}
                      >
                        <option value="select" disabled="">
                          Please select
                        </option>
                        <option value="Manhattan">Manhattan</option>
                        <option value="Washington">Washington</option>
                        <option value="Jersey">Jersey</option>
                        <option value="San Fran">San Fran</option>
                        <option value="Santa Monica">Santa Monica</option>
                        <option value="Miami">Miami</option>
                        <option value="Boston">Boston</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="newInventory__button-container">
                  <div className="newInventory__button-wrapper">
                    <button
                      onClick={this.handleCancel}
                      className="newInventory__button--cancel"
                    >
                      Cancel
                    </button>
                    <button
                      className="newInventory__button--save"
                      type="submit"
                    >
                      + Add Item
                    </button>
                  </div>
                </div>
              </form>
            </section>
          </div>
        </div>
      </>
    );
  }
}

export default NewInventoryItem;
